<template>
  <FormInput
    v-model="modelValue"
    class="DateInput"
    type="date"
    iconName="calendar"
    v-bind="{name, isRequired}"
    @input="haptic()"
  />
</template>

<script lang="ts" setup>
import FormInput from "@/components/FormInput.vue";
import haptic from "@/lib/utils/platform/haptic";

const modelValue = defineModel<string | null>({
  required: true,
});

defineProps<{
  name: string,
  isRequired?: boolean,
}>();
</script>
